(() => {
  const SELECTOR = '[data-etp-blog-posts]';

  const stripHtml = (html = '') => {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  };

  const escapeHtml = (value = '') => {
    const div = document.createElement('div');
    div.textContent = value;
    return div.innerHTML;
  };

  const truncate = (value = '', limit = 160) => {
    const text = value.trim();
    if (text.length <= limit) return text;
    return `${text.slice(0, limit).trim()}...`;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    if (Number.isNaN(date.getTime())) {
      return { iso: '', label: '' };
    }

    return {
      iso: date.toISOString().slice(0, 10),
      label: date.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      }),
    };
  };

  const getFeaturedImage = (post, fallbackImage) => {
    const media = post?._embedded?.['wp:featuredmedia']?.[0];

    return media?.media_details?.sizes?.large?.source_url
      || media?.media_details?.sizes?.medium_large?.source_url
      || media?.source_url
      || fallbackImage;
  };

  const renderPost = (post, settings) => {
    const title = stripHtml(post?.title?.rendered || '');
    const excerpt = truncate(stripHtml(post?.excerpt?.rendered || ''), 160);
    const link = (post?.link || '#').replace(
      'blog.exquisitetimepieces.com',
      'www.exquisitetimepieces.com/blog'
    );
    const image = getFeaturedImage(post, settings.fallbackImage);
    const date = formatDate(post?.date);

    return `
       <div class="col-12 col-md-6 col-xl-3">
    <article class="etp-blog-card">
      <a href="${escapeHtml(link)}" class="etp-blog-card__image-wrapper">
        <img
          
          src="${escapeHtml(image)}"
          alt="${escapeHtml(title)}"
          class="etp-blog-card__image etplazy"
          loading="lazy"
        >
      </a>

      <div class="etp-blog-card__body">
        ${date.label ? `
          <time datetime="${date.iso}" class="etp-blog-card__date">
            ${date.label}
          </time>
        ` : ''}

        <h3 class="etp-blog-card__title">
          <a href="${escapeHtml(link)}">
            ${escapeHtml(title)}
          </a>
        </h3>

        <p class="etp-blog-card__excerpt">
          ${escapeHtml(excerpt)}
        </p>
      </div>
    </article>
  </div>
    `;
  };

  const loadBlogPosts = async (section) => {
    const grid = section.querySelector('[data-etp-blog-grid]');

    if (!grid || section.dataset.loaded === 'true') return;

    section.dataset.loaded = 'true';

    const apiUrl = section.dataset.apiUrl;
    const limit = Number(section.dataset.limit || 4);

    const settings = {
      fallbackImage: section.dataset.fallbackImage || '',
      placeholderImage: section.dataset.placeholderImage || '',
    };

    try {
      const url = new URL(apiUrl);
      url.searchParams.set('per_page', limit);

      if (!url.searchParams.has('_embed')) {
        url.searchParams.set('_embed', 'wp:featuredmedia');
      }

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`WordPress API error: ${response.status}`);
      }

      const posts = await response.json();

      if (!Array.isArray(posts) || !posts.length) {
        section.remove();
        return;
      }

      grid.innerHTML = posts.slice(0, limit).map((post) => renderPost(post, settings)).join('');

      document.dispatchEvent(new CustomEvent('etp:wordpress-blog-loaded', {
        detail: {
          section,
          posts,
        },
      }));
    } catch (error) {
      console.error('[ETP Blog Posts]', error);
      section.remove();
    }
  };

  const initSection = (section) => {
    if (!section || section.dataset.initialized === 'true') return;

    section.dataset.initialized = 'true';

    if (!('IntersectionObserver' in window)) {
      loadBlogPosts(section);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        observer.disconnect();
        loadBlogPosts(section);
      });
    }, {
      rootMargin: '300px 0px',
    });

    observer.observe(section);
  };

  const init = () => {
    document.querySelectorAll(SELECTOR).forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector?.(SELECTOR) || event.target.matches?.(SELECTOR) && event.target;

    if (section) initSection(section);
  });
})();
